document.addEventListener('DOMContentLoaded', () => {
   const menuBurger = document.querySelector('.js-button-menu')
   const buttonCloseMenu = document.querySelector('.js-button-close');
   const menuItemsButtonDropdown = document.querySelectorAll('.js-button-open-submenu');
   const menuMobile = document.querySelector('.js-mobile-menu');
   const menuMobileWrapper = menuMobile.querySelector('.data-wrapper');
   const htmlBody = document.querySelector('body');

   const closeMobileMenu = () => {
      menuMobileWrapper.classList.remove('active');
      menuBurger.classList.remove('active');
      menuMobile.classList.remove('active');
      htmlBody.classList.remove('overflow-hidden');
   }

   menuBurger.addEventListener('click', function () {
      menuBurger.classList.toggle('active');
      menuMobile.classList.toggle('active');
      menuMobileWrapper.classList.toggle('active');
      htmlBody.classList.toggle('overflow-hidden');
   });


   buttonCloseMenu.addEventListener('click', function () {
      closeMobileMenu();
   });

   window.addEventListener('click', function (event) {
      if (!event.target.closest('.data-wrapper')) {
         closeMobileMenu();
      }
   });

   // Add touchstart event handler for mobile device
   window.addEventListener('touchstart', function (event) {
      if (!event.target.closest('.data-wrapper')) {
         closeMobileMenu();
      }
   });

   menuItemsButtonDropdown.forEach(function (menuItemButtonDropdown) {
      menuItemButtonDropdown.addEventListener('click', function () {
         menuItemButtonDropdown.classList.toggle('active');

         const menuItemParent = menuItemButtonDropdown.closest('li');
         if (menuItemParent) {
            menuItemParent.classList.toggle('active');
         }
      });
   });
});